<template>
  <div id="toast" v-bind:style="{ display:calcShow }">
    <div class="weui-mask_transparent"></div>
    <div class="weui-toast">
        <i class="weui-loading weui-icon_toast" v-if="Show == 'loading'"></i>
        <i class="fa fa-okla failed-no-circle weui-icon_toast" v-if="Show == 'success'"></i>
        <i class="fa fa-shandianmao failed-no-circle weui-icon_toast" v-if="Show == 'failed'"></i>
        <!--<mu-circular-progress :size="40" color="white" />-->
        <p class="weui-toast__content">{{ calcMsg }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name:"XR-toast",
  data () {      
    return {
      Show : '',
      MsgValue : ''
    }
  },
  computed: {
    calcShow: function(){
      return this.Show == '' ? 'none':'block'
    },
    calcMsg : function(){
      return this.MsgValue? this.MsgValue : this.Msg ? this.Msg :'加载中...';
    }
  },
  methods: {
    load: function(Msg, autoClose){
      this.MsgValue = Msg;
      this.Show = 'loading'
      if(autoClose){
        this.showAutoClose()
      }
    },
    failed: function(Msg,autoClose){
      this.MsgValue = Msg;
      this.Show = 'failed'
      if(autoClose){
        this.showAutoClose()
      }
    },
    success: function(Msg,autoClose){
      this.MsgValue = Msg
      this.Show = 'success'
      if(autoClose){
        this.showAutoCloseEmit()
      }
    },
    successCallback: function(Msg, callback){
      this.MsgValue = Msg
      this.Show = 'success'
      if(typeof callback == 'function'){
        var obj = this;
        setTimeout(function(){
          obj.hide();
          callback();
        },1500)
      }
    },
    showAutoClose: function(){
      var obj = this;
      setTimeout(function(){
        obj.hide();
      },1500)
    },
    showAutoCloseEmit: function(){
      var obj = this;
      setTimeout(function(){
        obj.hide();
        obj.$emit('onClose')
      },1500)
    },
    hide :function(autoClose){
      var obj = this;
      this.Show = ''
      this.MsgValue = '加载中...';
      if(autoClose){
        obj.$emit('onClose')
      }
    },
  }
}
</script>
<style>
#toast .weui-mask_transparent{
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
}

#toast .weui-toast{
    position:fixed;
    z-index:20190529;
    width:7.6em;
    min-height:7.6em;
    top:40%;
    left:50%;
    margin-left:-3.8em;
    background:rgba(17, 17, 17, 0.7);
    text-align:center;
    border-radius:5px;
    color:#FFFFFF;
  }
 #toast .weui-icon_toast{
    margin:22px 0 0;
    display:block;
  }
 #toast .weui-icon_toast.weui-icon-success-no-circle:before{
    color:#FFFFFF;
    font-size:55px;
  }
 #toast .weui-icon_toast.failed-no-circle{
    color:#FFFFFF;
    font-size:42px;
    height: 50px;
  }
 #toast  .weui-icon_toast.weui-loading{
    margin:30px 0 0;
    width:38px;
    height:38px;
    vertical-align:baseline;
  }
 #toast .weui-toast__content{
    margin:0 0 15px;
  }

 #toast  .weui-loading {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    animation: weuiLoading 1s steps(12, end) infinite;
    background: transparent url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTlFOUU5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMwKSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iIzk4OTY5NyIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgzMCAxMDUuOTggNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjOUI5OTlBIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDYwIDc1Ljk4IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0EzQTFBMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NSA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNBQkE5QUEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwIDU4LjY2IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0IyQjJCMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgxNTAgNTQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjQkFCOEI5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA1MCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDMkMwQzEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1MCA0NS45OCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDQkNCQ0IiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEyMCA0MS4zNCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNEMkQyRDIiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDM1IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0RBREFEQSIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNjAgMjQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTJFMkUyIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAtNS45OCA2NSkiLz48L3N2Zz4=) no-repeat;
    background-size: 100%;
  }
  @-webkit-keyframes weuiLoading {
    0% {
      transform: rotate3d(0, 0, 1, 0deg);
    }
    100% {
      transform: rotate3d(0, 0, 1, 360deg);
    }
  }
  @keyframes weuiLoading {
    0% {
      transform: rotate3d(0, 0, 1, 0deg);
    }
    100% {
      transform: rotate3d(0, 0, 1, 360deg);
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/tools/toast.vue